import { NivalizInboundTransactionTimerDropOffPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../../pudo/pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface NivalizCoffinsAwaitingDropOffProps {
    accountId: string;
    navigateUrl?: string;
}

export const NivalizCoffinsAwaitingDropOff = ({ accountId, navigateUrl }: NivalizCoffinsAwaitingDropOffProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='platform.statistics.nivaliz.coffins-awaiting-drop-off.title'
                description='Title of the Nivaliz dashboard stacked bar showing coffins awaiting drop-off grouped by waiting time'
                defaultMessage='Coffins: Awaiting drop-off'
            />
        }
        Chart={NivalizInboundTransactionTimerDropOffPendingWaitingDaysStackedBarChart}
    />
);
